export default __webpack_public_path__ + "static/media/olapic.aced45c1.svg";